var map = {
	"./add.svg": 7969,
	"./addfolder.svg": 4580,
	"./camera.svg": 6514,
	"./copy.svg": 8135,
	"./delete-modal.svg": 5001,
	"./delete.svg": 4131,
	"./document.svg": 4735,
	"./down.svg": 5583,
	"./group.svg": 3867,
	"./monitor.svg": 6035,
	"./openfolder.svg": 5397,
	"./playlist.svg": 2009,
	"./remove.svg": 3712,
	"./rename.svg": 5552,
	"./schedule.svg": 3068,
	"./settings.svg": 5312,
	"./slideshow.svg": 826,
	"./type-monitor.svg": 6495,
	"./type-stream.svg": 9050,
	"./type-video.svg": 4743,
	"./type-web.svg": 5751,
	"./up.svg": 2774,
	"./warning-modal.svg": 8204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9001;